module.exports = __webpack_public_path__ + "static/media/romio-modenesi.6658a563.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/romio-modenesi.jpg
// module id = 814
// module chunks = 0